module.exports = {
  "@primary-color":"#001860",
  "@link-color":"#2893ea",
  "@redMain":"#8690ad",
  "@greyDark":"#35383C"
};
